<template>
 <div class="eating-body">
   <img src="https://jiaofu-qianduan.oss-cn-chengdu.aliyuncs.com/common/nyg/china-nyg.png" />
 </div>
</template>

<script>
export default {
  created() {
    document.title='中国牛油果'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eating-body {
  max-width: 750px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
}
.eating-body img {width: 100%}
</style>



// WEBPACK FOOTER //
// src/components/page/h5/china-nyg.vue